//External
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import dynamic from "next/dynamic";

//Internal
import Header from "../header";
import Footer from "../footer";
// import MetaTags from "../meta-tags";

// const Footer = dynamic(() => import("../footer"));
const MetaTags = dynamic(() => import("../meta-tags"));

import { withRouter } from "next/router";
import { get_cookie, remove_cookie } from "utils";
// import CookiesModal from "components/modals/cookiesModal";

/*******************
@Purpose : Used for  Layout
@Parameter : {addressInfo,brandList,categoryList,currentPage,currentLocationId,cmsList,children,
  dynamicPageList,headerDark,headerSticky,isShowAddressInfo,loaders,locations,metaData,selectedLocationName}
@Author : INIC
******************/
const Layout = ({
  addressInfo,
  brandList,
  categoryList,
  currentPage,
  currentLocationId,
  cmsList,
  children,
  dynamicPageList,
  headerDark,
  headerWhite,
  headerSticky,
  isShowAddressInfo,
  loaders,
  locations,
  metaData,
  selectedLocationName,
  brandBannerInfo,
  categoryBannerInfo,
  vehicalDetailData,
  cityNameForMeta,
  homePageData,
}) => {
  const is_mobile_app = get_cookie("is_mobile_app");
  const [showPageLoader, setShowPageLoader] = useState(
    currentPage == "home" ||
      currentPage == "dynamic" ||
      currentPage == "brand" ||
      currentPage == "category" ||
      currentPage == "vehicle" ||
      currentPage == "cms" ||
      currentPage == "blogdetail"
      ? true
      : false
  );

  useEffect(() => {
    setTimeout(() => {
      setShowPageLoader(false);
    }, 1200);
    remove_cookie("swp");
  }, []);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <div
      className={
        headerSticky ? "main-wrapper header-sticky" : "d-flex flex-column h-100"
      }
    >
      {/* {loaders && loaders.content_loader && <ContentLoader />} */}
      {/* {showPageLoader && <ContentLoader />} */}

      {/****************
        @purpose : SEO Intigration
        @Author : INIC
        ******************/}
      <MetaTags
        metaData={metaData}
        currentPage={currentPage}
        brandBannerInfo={brandBannerInfo}
        categoryBannerInfo={categoryBannerInfo}
        vehicalDetailData={vehicalDetailData}
        cityNameForMeta={cityNameForMeta}
        homePageData={homePageData}
        addressInfo={addressInfo}
      />
      {/*******************
          @purpose :Header Components
          @Author : INIC
          ******************/}
      {is_mobile_app !== "yes" && (
        <Header
          locations={locations}
          brandList={brandList}
          categoryList={categoryList}
          currentLocationId={currentLocationId}
          headerDark={headerDark}
          headerWhite={headerWhite}
          selectedLocationName={selectedLocationName}
          currentPage={currentPage}
          addressInfo={addressInfo}
        />
      )}

      <main className="main-layout flex-shrink-0"> {children} </main>

      {/*******************
          @purpose :Footer Components
          @Author : INIC
          ******************/}
      {is_mobile_app !== "yes" && (
        <Footer
          locations={locations}
          brandList={brandList}
          categoryList={categoryList}
          addressInfo={addressInfo}
          dynamicPageList={dynamicPageList}
          currentLocationId={currentLocationId}
          isShowAddressInfo={isShowAddressInfo}
          selectedLocationName={selectedLocationName}
          cmsList={cmsList}
          currentPage={currentPage}
        />
      )}
      {/* {is_mobile_app !== "yes" && <CookiesModal />} */}
    </div>
  );
};

/********************
@purpose : Connect With Redux
@Parameter : {ui, layout}
@Author : INIC
******************/
const mapStateToProps = ({ ui }) => ({
  loaders: ui && ui.loaders,
});
export default withRouter(connect(mapStateToProps)(Layout));
